{ Analytics, Action, ActionSubject, ActionSubjectId, Source } = require '@trello/atlassian-analytics'
Auth = require 'app/scripts/db/auth'
MemberOnBoardView = require 'app/scripts/views/member-menu-profile/member-on-board-view'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
template = require 'app/scripts/views/templates/jsw-crossflow-popover'
idToDate = require('app/common/lib/util/date').idToDate
{ truncate } = require 'app/common/lib/util/text/truncate'
_ = require 'underscore'

{ ProductKeys } = require '@atlassiansox/product-store-react'
{ defaultStore } = require 'app/gamma/src/defaultStore'
{ OverlayType, setOverlay } = require 'app/gamma/src/modules/state/ui/overlay'
{ UtmCampaign } = require 'app/gamma/src/util/cross-flow-essentials'
module.exports = class JswCrossflowPopoverView extends View
  className: 'jsw-crossflow-popover-wrapper'

  renderCrossflow: ->
    defaultStore.dispatch(
      setOverlay({
        overlayType: OverlayType.ProductStore,
        productKey: ProductKeys.JIRA_SOFTWARE,
        context: {
          source: 'try',
          campaign: UtmCampaign.TOUCHPOINTS_JSW_BOARD,
        }
      })
    )
    Analytics.sendUIEvent
      action: Action.clicked
      actionSubject: ActionSubject.button
      actionSubjectId: ActionSubjectId.jswLearnMoreButton
      source: Source.jswLearnMoreInlineDialog
      containers:
        board:
          id: @model.id

  events:
    'click .js-close-orientation': 'onClose'
    'click .jsw-crossflow-popover-button': 'renderCrossflow'

  render: ->
    @$el.html(template())
    Analytics.sendUIEvent
      action: Action.viewed
      actionSubject: ActionSubject.inlineDialog
      actionSubjectId: ActionSubjectId.jswLearnMoreInlineDialog
      source: Source.boardScreen
      containers:
        board:
          id: @model.id

    $messageContainer = @$el.find('.jsw-crossflow-popover-message-container')
    $avatarContainer = @$el.find('.jsw-crossflow-popover-avatar-container')
    setTimeout (=>$avatarContainer.addClass('active')), 1200
    setTimeout (=>$messageContainer.addClass('active')), 1350

    @

  onClose: ->
    # make it so it won't show up again.
    Auth.me().dismiss('jsw-crossflow-popover')
    @remove()
    Analytics.sendUIEvent
      action: Action.dismissed
      actionSubject: ActionSubject.inlineDialog
      actionSubjectId: ActionSubjectId.jswLearnMoreInlineDialog
      source: Source.boardScreen
      containers:
        board:
          id: @model.id
